<div class="product-info-card">
  <h2><b>{{cardTitle}}</b></h2>
  <p>{{cardInfo}}</p>
  @if (cardQuestion) {
    <b ><em>{{cardQuestion}}</em></b>
  }
  @if (cardQuestion) {
    <table >
      <colgroup>
      <col span="1" style="width: 30%;">
      <col span="1" style="width: 70%;">
    </colgroup>
    <tbody>
      <tr>
        <td><img src="{{cardFirstReasonImgSrc}}" alt="{{cardFirstReasonImgAlt}}" /></td>
        <td>{{cardFirstReason}}</td>
      </tr>
      <tr>
        <td><img src="{{cardSecondReasonImgSrc}}" alt="{{cardSecondReasonImgAlt}}" /></td>
        <td>{{cardSecondReason}}</td>
      </tr>
    </tbody>
  </table>
}
<button (click)="redirectForm()" >{{cardButton}}</button>
</div>